import I18n, { ToNumberOptions } from "i18n-js"

export const displayPoints = (points: number, options?: ToNumberOptions) => {
  const withDelimiter = I18n.toNumber(points, options || { precision: 0 })
  return (points > 0) ? `+${withDelimiter}` : withDelimiter
}